import React from "react";
import { useContext, useState } from "react";
import SimpleContext from "../context/SimpleContext";
import right from "../img/right.png";
import user from "../img/user.png";
import phone from "../img/phone.png";
import home from "../img/home.png";
import { useHistory } from "react-router";
import config from "./../../services/config.json";
import useLocalStorageState from "use-local-storage-state";
import Preloader from "../common/Preloader2";
import { browserName, browserVersion } from "react-device-detect";
const ProfileView = () => {
  // const imageToBase64 = require("image-to-base64");
  const context = useContext(SimpleContext);
  const [UploadedImage, setUploadedImage] = useState(0);
  const [UsersUploadedImage, setUsersUploadedImage] = useLocalStorageState(
    "UsersUploadedImage",
    []
  );
  const [ShowUploadBtn, setShowUploadBtn] = useLocalStorageState(
    "ShowUploadBtn",
    false
  );
  const [selectedImage, setSelectedImage] = useState("");
  const [pre, setpre] = useState(false);
  const history = useHistory();
  function Upload() {
    setpre(true);
    async function getData() {
      let MyTime = Date.now();
      let TimeHeader = context.Encriptor(context.timeMiliSecondDef + MyTime);

      const myheaders = {
        "atu-token": TimeHeader,
      };
      const url = `${context.baseUrlApiPakhsh}${config.updateProfileImage}`;
      const data = {
        customerId:
          Object.values(context.UseInFo).length > 0 &&
          Object.values(context.UseInFo).length > 0 &&
          context.UseInFo.customerId,
        imageBase64: UploadedImage,
        appVersion: browserName,
        AndroidVersion: browserVersion,
        deviceId: context.UniqueUUID,
        appTypeId: context.AppType,
      };
      const param = {
        method: "post",
        body: JSON.stringify(data),
        headers: myheaders,
      };

      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setpre(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        if (parseInt(data.code) === 400) {
          setShowUploadBtn(false);
          context.HandelShowContentPage2("6");

          //checkcustomer
          let MyTime = Date.now();
          let TimeHeader = context.Encriptor(
            MyTime + context.timeMiliSecondDef
          );

          const myheaders = {
            "atu-token": TimeHeader,
          };
          async function getData() {
            const url = `${context.baseUrlApiPakhsh}${config.customerCheck}`;
            const formData = new FormData();
            formData.append("mobile", context.UseInFo.mobile);
            formData.append("appTypeId", context.AppType);
            formData.append("appVersion", browserName);
            formData.append("AndroidVersion", browserVersion);
            formData.append("deviceId", context.UniqueUUID);
            formData.append(
              "customerId",
              Object.values(context.UseInFo).length > 0 &&
                Object.values(context.UseInFo).length > 0 &&
                context.UseInFo.customerId
            );

            const param = {
              method: "post",
              body: formData,
              headers: myheaders,
            };
            const sendRequest = await fetch(url, param);
            const response = await sendRequest.json();
            return response;
          }
          try {
            getData().then((data) => {
              context.setUseInFo(data.response);
              if (data.popUp !== null) {
                if (data.popUp.text === "" && data.popUp.imageLink === "") {
                  window.open(data.popUp.link, "noopener,noreferrer");
                } else {
                  context.setmodalPopUp(true);
                  context.setTextPopUp(data.popUp);
                }
              } else {
                context.setmodalPopUp(false);
              }
              if (data.code === 200) {
                context.setUseInFo(data.response);
              }
            });
          } catch (ex) {
            console.log(ex);
          }
        } else if (parseInt(data.code) === 401) {
          context.setshowModalTime(true);
        } else {
          context.HandelShowContentPage("7");
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setUsersUploadedImage(URL.createObjectURL(event.target.files[0]));
      setSelectedImage(event.target.files[0]);
      setShowUploadBtn(true);

      const file = document.getElementById("file").files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        setUploadedImage(reader.result.replace("data:image/jpeg;base64,", ""));
      };
      reader.onerror = function (error) {};
    }
  };

  const goSavabegh = () => {
    context.setShowKfp(false);
    context.setShowApi(true);
    context.handleHistoryPush("/savabegh");
  };

  return (
    <>
      {context.UseInFo !== null &&
        Object.values(context.UseInFo).length > 0 && (
          <>
            <div className="productsmain">
              <div className="otherPagesHeader">
                <div className="barbuttonn">
                  <img
                    onClick={() => history.go(-1)}
                    className="backIcon"
                    src={right}
                  />
                </div>
                <div className="headersNames">
                  <p style={{ margin: "0" }}>مشخصات کاربر</p>
                </div>
                <div style={{ width: "20%", visibility: "hidden" }}>
                  <p style={{ marginTop: "3%", fontSize: "13px" }}>hide text</p>
                </div>
              </div>

              <div className="personalInfoWholwPage">
                <div className="personalSubPlace">
                  <div className="UserImagePlace">
                    <h6 style={{ fontWeight: "bold" }}>مشخصات کاربر</h6>
                    {/* <img src="images/placeholder_profile.jpg" alt="personalImg" className="PersonalImg"
                                onClick={()=>picpicture()}
                            /> */}
                    <div
                      className="userImagePlace2"
                      style={{
                        backgroundImage:
                          UsersUploadedImage.length > 0
                            ? "url(" + `${UsersUploadedImage}` + ")"
                            : context.UseInFo.image !== ""
                            ? "url(" + `${context.UseInFo.image}` + ")"
                            : "url(" + "images/placeholder_profile.jpg" + ")",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                        border: "2px solid lightgray",
                      }}
                    >
                      <input
                        type="file"
                        id="file"
                        name="myfile"
                        className="userImage"
                        onChange={(event) => onImageChange(event)}
                      />
                    </div>
                    {ShowUploadBtn === true ? (
                      pre === true ? (
                        <button className="UploadImageButton">
                          <Preloader />
                        </button>
                      ) : (
                        <button
                          className="UploadImageButton"
                          onClick={() => Upload()}
                        >
                          آپلود عکس
                        </button>
                      )
                    ) : null}
                  </div>
                  <br />
                  <div className="UserInfoMainPlace">
                    <div className="infoPlace">
                      <img style={{}} src={user} />
                      {/* <i className="fa fa-user" style={{color:"gray",width:'30px'}}/> */}
                      <div className="userinfo">
                        <p className="infoTitle">نام کاربر</p>
                        <p className="infotext">
                          {context.UseInFo.customerName}
                        </p>
                      </div>
                    </div>
                    <hr style={{ margin: "0", padding: "0" }} />
                    <div className="infoPlace">
                      <img style={{}} src={phone} />
                      {/* <i className="fa fa-phone" style={{color:"gray"}}/> */}
                      <div className="userinfo">
                        <p className="infoTitle">شماره موبایل</p>
                        <p className="infotext">{context.UseInFo.mobile}</p>
                      </div>
                    </div>
                    <hr style={{ margin: "0", padding: "0" }} />
                    <div className="infoPlace">
                      <img style={{ width: "25px" }} src={home} />
                      {/* <i className="fa fa-home" style={{color:"gray"}}/> */}
                      <div className="userinfo">
                        <p className="infoTitle">آدرس</p>
                        <p className="infotext">{context.UseInFo.address}</p>
                      </div>
                    </div>
                    <hr style={{ margin: "0", padding: "0" }} />
                    <div
                      style={{ justifyContent: "space-around" }}
                      className="infoPlace"
                    >
                      <button
                        className="UserInfoBtn"
                        onClick={() => goSavabegh()}
                      >
                        سوابق خرید
                      </button>
                      {/* <button
                  className="UserInfoBtn"
                  onClick={() => context.handleHistoryPush("/TarikhTahvil")}
                >
                  زمان تحویل شهر شما
                </button> */}
                    </div>
                    {/* <br/> */}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
    </>
  );
};

export default ProfileView;
